export default __webpack_public_path__ + "static/media/icon8.fb1d62d7.svg";